
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_t7p6b_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_t7p6b_14",
  "token-field-container": "awsui_token-field-container_vm8qf_t7p6b_18",
  "token-field": "awsui_token-field_vm8qf_t7p6b_18",
  "token-field-disabled": "awsui_token-field-disabled_vm8qf_t7p6b_56",
  "token-field-readonly": "awsui_token-field-readonly_vm8qf_t7p6b_64",
  "token-field-invalid": "awsui_token-field-invalid_vm8qf_t7p6b_70",
  "token-field-warning": "awsui_token-field-warning_vm8qf_t7p6b_82",
  "grouped": "awsui_grouped_vm8qf_t7p6b_94",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vm8qf_t7p6b_100",
  "grouped-in-error": "awsui_grouped-in-error_vm8qf_t7p6b_107",
  "grouped-in-warning": "awsui_grouped-in-warning_vm8qf_t7p6b_112",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vm8qf_t7p6b_127",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vm8qf_t7p6b_151",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vm8qf_t7p6b_178",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vm8qf_t7p6b_205",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vm8qf_t7p6b_229",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_vm8qf_t7p6b_256",
  "grouped-vertical-only": "awsui_grouped-vertical-only_vm8qf_t7p6b_256",
  "grouped-with-action": "awsui_grouped-with-action_vm8qf_t7p6b_286",
  "grouped-validation": "awsui_grouped-validation_vm8qf_t7p6b_296",
  "token-field-icon": "awsui_token-field-icon_vm8qf_t7p6b_301",
  "token-list": "awsui_token-list_vm8qf_t7p6b_307",
  "inline-tokens": "awsui_inline-tokens_vm8qf_t7p6b_321",
  "token-list-item": "awsui_token-list-item_vm8qf_t7p6b_325",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_t7p6b_329",
  "token-overflow": "awsui_token-overflow_vm8qf_t7p6b_336",
  "token-overflow-trigger": "awsui_token-overflow-trigger_vm8qf_t7p6b_340",
  "overflow-dropdown": "awsui_overflow-dropdown_vm8qf_t7p6b_344",
  "overflow-dropdown-item": "awsui_overflow-dropdown-item_vm8qf_t7p6b_353",
  "measurement-container": "awsui_measurement-container_vm8qf_t7p6b_359",
  "measurement-token": "awsui_measurement-token_vm8qf_t7p6b_372"
};
  